// External dependencies
import React, { useEffect, useState } from 'react';

// Internal dependencies
import { getMenu } from '@/modules/cms/client/api/cms.api';

/**
 * Links to CMS pages flagged for the site menu, for the public footer.
 *
 * Renders nothing when the menu is empty or the request fails — a CMS outage
 * must never take the footer down with it.
 */
export default function CmsMenuLinks() {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    let cancelled = false;

    getMenu()
      .then(data => {
        if (!cancelled && Array.isArray(data)) {
          setPages(data);
        }
      })
      .catch(() => {
        // Deliberately silent: an empty menu is the correct degraded state.
        if (!cancelled) {
          setPages([]);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (!pages.length) {
    return null;
  }

  return (
    <>
      {pages.map(page => (
        <li key={page.slug}>
          <a href={`/pages/${page.slug}`}>{page.title}</a>
        </li>
      ))}
    </>
  );
}

CmsMenuLinks.propTypes = {};
